app.controller('propertySearchController', function ($scope, $rootScope, $location, safeApply, searchService, systemService) {
  
  init()

  // try {
  //   Intercom('boot',  {
  //       app_id                  : "qme4eg2m",
  //       hide_default_launcher   : false,
  //       alignment               : 'right',
  //       custom_launcher_selector: '.open_intercom',
  //       horizontal_padding      : 2,
  //       vertical_padding        : 2
  //     })
  //   try {
  //       Intercom("update")
  //     } catch (error) { console.log(error); }
  //   } catch (error) { console.log(error); }
  
  // Advanced Search ---------------------------------------------------------------

  // By Tax ID -------------------------
  $scope.queryTaxid = async function (searchText) {
    let obj = {
      cad_code: $scope.searchObj.county.cad_code,
      prop_uid: `${$scope.searchObj.county.cad_code}${searchText}`
    }
    let getTaxIdResults = await searchService.getTaxIDs(obj)
    console.log('getTaxIdResults :>> ', getTaxIdResults);
    return getTaxIdResults.data.data.map(function(item) {
        return {
          display : item.full_address,
          value   : item.full_address.toLowerCase(),
          entryID : item.id,
          prop_uid: item.prop_uid,
          address : item.usps_full_address,
          account : item.account,
          owner   : item.owner_name,
          division: item.division,
          cad_code: item.cad_code,
          fullData: item
        }
      })
  }

  $scope.onTaxidSelect = (item) => {
    if (!item) return false
    try {
      $scope.searchObj.properties[0]  = item
      $scope.searchObj.property_found = true
      console.log('$scope.searchObj. :>> ', $scope.searchObj);
    } catch (error) { console.log('error :>> ', error);}
  }  
  // END: By Tax ID --------------------


  // By Address --------------
  $scope.queryStreets = async function (searchText) {
    let obj = {
      cad_code: $scope.searchObj.county.cad_code,
      situs   : { num: $scope.searchObj.address.number, street: searchText}
    }
    let getStreetsResults = await searchService.getStreets(obj)
    return getStreetsResults.data.data.map(function(item) {
        return {
          display : item.full_address,
          value   : item.full_address.toLowerCase(),
          entryID : item.id,
          prop_uid: item.prop_uid,
          address : item.usps_full_address,
          account : item.account,
          owner   : item.owner_name,
          division: item.division,
          cad_code: item.cad_code,
          fullData: item
        }
      })
  }

  $scope.onStreetSelect = (item) => {
    console.log("onStreetSelect", item);
    try {
      $scope.searchObj.properties[0]  = item
      $scope.searchObj.property_found = true
    } catch (error) {
      console.log('error :>> ', error);
     }
  }
      
  $scope.countyAndStreetSelected = () => {
    return !($scope.searchObj.county.cad_code != "" && $scope.searchObj.address.number.length > 0)
  }

  // END:  Advanced Search ---------------------------------------------------------------

  

  $scope.initGoogleSearch = () => {
    autocomplete = new google.maps.places.Autocomplete(
      (document.getElementById('autocomplete')), { types: ['address'], componentRestrictions: { country: "us" } }
    )
    setTimeout(function () {
      document.querySelector("#autocomplete").focus()
    }, 2000)
    autocomplete.addListener('place_changed', function () {
      $scope.subAddressSearch('addSearch_google')
    })
    // $("body").trigger("resize")
  }

  $scope.propertySelected = async (prop_index) => {   
    $scope.regAnalysis  = { analysis_running: true}
    const p             = $scope.searchObj.properties[prop_index]
    let   search_method = searchService.getSearchMethod()
        
    switch (search_method) {
      case 1: // Base Search - Show Analysis
        systemService.route_change('analysis', { uid: p.prop_uid })        
        break
      case 2: // File a Protest Search - Take to Registration
        systemService.route_change('registration', { cad_code: p.cad_code, account: p.account })
        break
    }
    safeApply($scope)
    
    return


    let   obj = {
      cad_account: p.account,
      cad_code   : p.cad_code,
      detail     : 'registration'
    }
    console.log('obj :>> ', obj);
    let performAnalysisResults = await searchService.performAnalysis(obj)
    console.log('performAnalysisResults :>> ', performAnalysisResults);
    $scope.regAnalysis.analysis_running = false
    if (performAnalysisResults.data.success == true) {
      $scope.regAnalysis              = {... $scope.regAnalysis, ...performAnalysisResults.data.data}
      $scope.regAnalysis.full_address = p.full_address
      $scope.regAnalysis.cad_account  = p.account
      $scope.regAnalysis.cad_code     = p.cad_code
      // if (performAnalysisResults.data.data.smartcomp_id < 1) {
      //   $scope.regAnalysis.edge_message = performAnalysisResults.data.data.edge_message
      // }
      
    } else {
      $scope.regAnalysis = {
        money_back_guarantee: false,
        smartcomp_id        : -9999,
        edge_message        : "The system was unable to run a PRE-ANALYSIS on this property, Please chat in with us for more information!"
      }
    }
    safeApply($scope)
  }

  $scope.countyChange = (obj) => {
    $scope.searchObj.county.name     = obj.name
    $scope.searchObj.county.cad_code = obj.cad_code
  }

  $scope.subAddressSearch = async function (type) {   
    var place = autocomplete.getPlace() || undefined
    if (place.formatted_address === undefined) {
      $scope.resetSearch()
      return
    }
    let googleSearchObj = searchService.convertGoogleResponseToObject(place)
    let searchObj       = angular.copy(googleSearchObj)

    // Let's do some basic validation
    // is this in Texas?
    if (searchObj.state.short_name != 'TX') {
      $scope.searchObj.error_message_id      = 1
      $scope.searchObj.error_message         = "Sorry, our services are limited to specific counties in Texas at this time."
      $scope.searchObj.properties            = []
      $scope.searchObj.show_button_try_again = true
      $scope.searchObj.show_button_chat      = false
      $scope.searchObj.property_found        = true
      safeApply($scope)
      return
    }
    // is this not a valid county for us?
    if (searchObj.cad_code == "000") {
      $scope.searchObj.error_message_id      = 2
      $scope.searchObj.error_message         = `Sorry, we do not have data for "${searchObj.county.long_name}" <br> Please try another county.`
      $scope.searchObj.properties            = []
      $scope.searchObj.show_button_try_again = true
      $scope.searchObj.show_button_chat      = false
      $scope.searchObj.property_found        = true
      safeApply($scope)
      return
    }
    // Create situs_street string
    //
    // Remove any direction indicators from the street name
    let streetName           = searchObj.street_name.short_name.toLowerCase()
    let streetNameArray      = streetName.split(" ")
    let firstWord            = streetNameArray[0]
    let firstWordIsDirection = ["n", "s", "e", "w", "n.", "s.", "e.", "w.", "north", "south", "east", "west"].includes(firstWord)
    if (firstWordIsDirection) streetNameArray.shift()
    searchObj.street_name.short_name = streetNameArray.join(" ").trim()

    console.log(searchObj);

    if (searchObj.street_name.short_name.split(' ').length > 1) {
      let secondWord                        = searchObj.street_name.short_name.split(" ")[1]
          secondWord                        = secondWord.charAt(0)
      let secondSearchParam                 = `${searchObj.street_name.short_name.split(" ")[0]} ${secondWord}`
          searchObj.street_name.short_name += `|${secondSearchParam}`
    }

    try {
      let obj = {
        cad_code    : searchObj.cad_code,
        full_address: searchObj.formatted_address,
        situs_num   : searchObj.street_number.short_name,
        situs_street: searchObj.street_name.short_name.trim(),
        app         : 'register'
      }
      console.log('obj :>> ', obj)
      let getPropUIDResults = await searchService.getPropUID(obj)
      
      console.log('getPropUIDResults :>> ', getPropUIDResults);

      if (getPropUIDResults.data.success && getPropUIDResults.data.data.length > 0) {
        if (getPropUIDResults.data.data.length > 1) {
          $scope.searchObj.error_message_id      = 3
          $scope.searchObj.error_message         = ``
          $scope.searchObj.show_button_try_again = true
          $scope.searchObj.show_button_chat      = true
          $scope.searchObj.properties            = []
          $scope.searchObj.property_found        = true
          safeApply($scope)  
          return
        }
        $scope.searchObj.properties     = getPropUIDResults.data.data
        $scope.searchObj.address        = encodeURIComponent(searchObj.formatted_address)
        $scope.searchObj.property_found = true
        safeApply($scope)
      } else {
        // Unable to find property in our DB
        $scope.searchObj.error_message_id      = 4
        $scope.searchObj.error_message         = ``
        $scope.searchObj.show_button_try_again = true
        $scope.searchObj.show_button_chat      = true
        $scope.searchObj.properties            = []
        $scope.searchObj.property_found        = false
        
        // Switch to Advanced search
        $scope.resetSearch()
        $rootScope.advancedSearch = true
        safeApply($scope)
        return
      }
    } catch (error) {
      $scope.searchObj.properties     = []
      $scope.searchObj.property_found = true
      safeApply($scope)
      return
    }
  }

  $scope.cancelAdvancedSearch = () => {
    $rootScope.advancedSearch = false
  }

  $scope.openChat = (message_id) => {
    let message = ''
    switch (message_id) {
      case 3:
        message = `My property is not a Condo or Multi-Tenant property.`
        break
    }
    Intercom('showNewMessage', message)
    safeApply($scope)
  }

  async function init() {
    resetSearchObj()
    let countyListResults     = await systemService.functionCall({ type: "countyList", active_only: true })
    if (countyListResults.data.success && countyListResults.data.data.length > 0) {
      $scope.counties = countyListResults.data.data
    } else {
      console.log("System Error")
    }
    safeApply($scope)
  }  

  function resetSearchObj() {
    $scope.searchObj = {
      google_search : null,
      county        : { name  : "Select County", cad_code: ""},
      address       : { number: "",              street  : "" },
      properties    : [{  prop_uid    : "",
                          full_address: "",
                          owner_name  : "",
                          division    : "",
                          account     : ""
                        }],
      property_found: false
    }
  }

  $scope.resetSearch = function () {
    console.log("resetSearch");
    $scope.regAnalysis = { analysis_running: false }
    angular.element(document.querySelector("#autocomplete")).val("")
    angular.element(document.querySelector("#autocomplete")).blur()
    $scope.streetSearchText = ""
    $scope.taxidSearchText  = ""
    setTimeout(function () {
      angular.element(document.querySelector("#autocomplete")).focus()
    }, 0)
    resetSearchObj()
  }


})